import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from "../../app.component";
import {Module, ModuleInfoPresentation, ModuleInfoExplanation} from "../../models/module.model";
import {NavigationEnd, Router} from "@angular/router";
import {RouterLinks} from "../../enums/router-links";
import {first, of, Subject, takeUntil} from "rxjs";
import {Question} from "../../models/question.model";
import {QstTypes} from "../../enums/qst-types";
import {Answer} from "../../models/answer.model";
import {SharedHelper} from "../../helpers/shared.helper";
import {ScreenTypes} from "../../enums/screen-types";
import {AuthGuard} from "../../helpers/auth-guard.helper";

@Component({
  selector: 'app-info',
  templateUrl: './module-intro.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./module-intro.component.less']
})
export class ModuleIntroComponent implements OnInit, OnDestroy {
  global_texts: any = null;
  module: Module | undefined;
  module_id: number = 1;
  module_title: string = '';
  mod_info_presentation!: ModuleInfoPresentation | null;
  screen: any = null;
  module_screens: any[] = [];
  private unsubscribe$ = new Subject<void>();

  constructor(
    public app: AppComponent,
    private router: Router,
    private authGuard: AuthGuard
  ) {
    // Subscribe to router events
    //this.router.events.subscribe((event) => {
    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log("NavigationEnd event INTRO => ", event);
        this.initializeComponentIntro();
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit(): void {
    this.initializeComponentIntro();
  }

  initializeComponentIntro() {
    let pathname: string = window.location.pathname;
    const parts = pathname.split('/');
    const _ref_page = parts[parts.length - 1];

    // Verify if the logout button was clicked
    if (this.authGuard.isLogoutClicked) {
      return;
    }

    // Get the global texts
    this.app.sharedHelper.getGlobalTexts().subscribe((texts: any) => {
      this.global_texts = texts;

      // Get the module by uuid
      //this.module = this.app.sharedHelper.getModule();
      //this.module = this.getModuleInfo();
      this.app.sharedHelper.getModule().then(module => {
        this.module = module;

        console.log("this.module => ", this.module)
        if (this.module) {
          // Get the info presentation
          this.module_title = this.module.module_presentation.title;
          this.mod_info_presentation = this.module.module_presentation;

          // Get Module Info from Front side
          let mod_info = this.app.sharedHelper.getFrontDatasForModuleByUuid(this.module.module_uuid);
          console.log("mod_info => ", mod_info);
          this.module_screens = mod_info.screens;
          this.screen = mod_info.screens.find((s: any) => s.ref === _ref_page && s.type === ScreenTypes.Intro);
          console.log("this.screen => ", this.screen);
        }
      });
    });
  }
}
